(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3823],{

/***/ 87526:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/select/pricing",
      function () {
        return __webpack_require__(96313);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ SiteBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86542);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76195);
/* harmony import */ var datocms_structured_text_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62338);



function SiteBanner(param) {
    var content = param.content, enabled = param.enabled;
    return enabled && !(0,datocms_structured_text_utils__WEBPACK_IMPORTED_MODULE_1__/* .isEmptyDocument */ .RL)(content) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "bg-stealth-bomber text-white px-7 py-4 flex justify-center text-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_datocms__WEBPACK_IMPORTED_MODULE_2__/* .StructuredText */ .rZ, {
            data: content,
            customMarkRules: [
                (0,react_datocms__WEBPACK_IMPORTED_MODULE_3__/* .renderMarkRule */ .zf)("strong", function(param) {
                    var children = param.children, key = param.key;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                        className: "font-medium",
                        children: children
                    }, key);
                }), 
            ]
        })
    }) : null;
}



/***/ }),

/***/ 96313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63430);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12569);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80338);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26499);
/* harmony import */ var _modules__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88038);
/* harmony import */ var _modules_site_banner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6985);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20978);
/* harmony import */ var _narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67199);
/* harmony import */ var _narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_6__);









var PricingPage = function(param) {
    var plans = param.plans, preview = param.preview, subscription = param.subscription;
    var ref = (0,react_datocms__WEBPACK_IMPORTED_MODULE_7__/* .useQuerySubscription */ .L)(subscription), tmp = ref.data, ref1 = tmp === void 0 ? {} : tmp, pages = ref1.pages, banner = ref1.banner;
    var data = pages === null || pages === void 0 ? void 0 : pages.find(function(page) {
        return page.parentPage.slug === "select";
    });
    if (!data) return null;
    var title = data.title, subheading = data.subheading, modules = data.modules, seo = data.seo;
    var modulesWithPlanData = (0,_modules__WEBPACK_IMPORTED_MODULE_3__/* .addPlanDataToModules */ .Df)(// TODO: Remove this filter once the testimonial carousel is removed from the cms page post launch
    // This is to allow us to accurately review the page in the staging environments
    modules.filter(function(m) {
        return m._modelApiKey !== "module_testimonial_carousel";
    }), plans);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_1__/* .Layout */ .Ar, {
        product: "select",
        preview: preview,
        siteBanner: banner ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_site_banner__WEBPACK_IMPORTED_MODULE_4__/* .SiteBanner */ .b, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, banner)) : null,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .SEO */ .HJ, {
                children: (0,react_datocms__WEBPACK_IMPORTED_MODULE_9__/* .renderMetaTags */ .y)(seo)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_6__.PromoBanner, {
                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "text-h1",
                    children: title
                }),
                description: subheading,
                textColour: "white",
                backgroundImagePath: "/images/textures/purple-bg-alt@2x.png",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_6__.AnchorButton, {
                    href: (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .createUrl */ .uJ)(_config__WEBPACK_IMPORTED_MODULE_2__/* .EXTERNAL.SELECT.GET_STARTED.HREF */ .IK.SELECT.GET_STARTED.HREF),
                    colour: "white",
                    className: "text-sm normal-case",
                    children: "Get Select Free"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules__WEBPACK_IMPORTED_MODULE_3__/* .ModuleToComponent */ .WT, {
                    modules: modulesWithPlanData,
                    addBackgroundColour: false
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (PricingPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(87526); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);